import moment from "moment";

/** Row shape used by history modals (sidebar, header, mobile nav). */
export type DepositWithdrawHistoryDisplayRow = {
	datetime: string;
	type: string;
	amount: string;
	remark: string;
	status: string;
};

/** Maps `hybridGetDepositWithdrawHistory` `data.records` to modal table rows. */
export function mapHybridDepositWithdrawHistoryResponse(
	data: unknown
): DepositWithdrawHistoryDisplayRow[] {
	const records = Array.isArray(data)
		? data
		: data &&
			  typeof data === "object" &&
			  Array.isArray((data as { records?: unknown }).records)
			? (data as { records: unknown[] }).records
			: [];

	return records.map((row: Record<string, unknown>) => {
		const amountNum = Number.parseFloat(
			String(row.hdw_trans_amount ?? "").trim()
		);
		const amount = Number.isNaN(amountNum)
			? String(row.hdw_trans_amount ?? "-")
			: amountNum.toFixed(2);

		const created = row.hdw_trans_created_dt;
		const m = moment(created);
		const datetime = m.isValid()
			? m.format("YYYY-MM-DD HH:mm:ss")
			: String(created ?? "-");

		const transactionType = String(row.transaction_type ?? "").trim();
		const methodType = String(row.hdw_trans_method_type ?? "").trim();

		return {
			datetime,
			type: transactionType || methodType || "-",
			amount,
			remark: methodType || "-",
			status: String(row.hdw_trans_status_type ?? "-").trim() || "-",
		};
	});
}
